import React from "react";

export const PresentationStyle = {
  TILE: "TILE",
  LIST: "LIST",
  GALLERY: "GALLERY",
  SMART: "SMART",
  TEMPLATES: "TEMPLATES",
} as const;

export type PresentationStyleType = typeof PresentationStyle[keyof typeof PresentationStyle];

export type PresentationStyleOption = {
  value: PresentationStyleType;
  Component: () => React.JSX.Element;
};
